import './App.scss';
import 'react-loading-skeleton/dist/skeleton.css';
import 'react-dadata/dist/react-dadata.css';

import { Route, Routes } from 'react-router';

import { MainLayout } from '@/components/MainLayout/MainLayout.tsx';
import { ProtectedRoute } from '@/components/ProtectedRoute/ProtectedRoute.tsx';
import { ScrollToTop } from '@/components/shared/ScrollToTop/ScrollToTop.tsx';
import { isMobile } from '@/constants';
import { ErrorPageNotFound } from '@/pages/404/ErrorPageNotFound.tsx';
import { AboutPage } from '@/pages/about/AboutPage.tsx';
import { DrugomaniyaPage } from '@/pages/drugomaniya/DrugomaniyaPage.tsx';
import { GoodTariffsPage } from '@/pages/good-tariffs/GoodTariffsPage.tsx';
import { HistoryPage } from '@/pages/history/HistoryPage.tsx';
import { HomePage } from '@/pages/home/HomePage.tsx';
import { MyNumbersPage } from '@/pages/my-numbers/MyNumbersPage.tsx';
import { MyReservationsPage } from '@/pages/my-reservations/MyReservationsPage.tsx';
import { PrettyNumbersPage } from '@/pages/pretty-numbers/PrettyNumbersPage.tsx';
import { PrivacyPolicyPage } from '@/pages/privacy-policy/PrivacyPolicyPage.tsx';
import { HelpPage } from '@/pages/profile/help/HelpPage.tsx';
import { LoyaltyProgramPage } from '@/pages/profile/loalty-program/LoyaltyProgramPage.tsx';
import { ProfilePage } from '@/pages/profile/ProfilePage.tsx';
import { SettingPage } from '@/pages/profile/settings/SettingPage.tsx';
import { TermsOfServicePage } from '@/pages/terms-of-service/TermsOfServicePage.tsx';
import { appRoutes } from '@/routes/app-routes.ts';

import { AppInitContainer } from './components/AppInitContainer/AppInitContainer.tsx';
import { MetrikaCounter } from 'react-metrika';
import { isProd } from '@/env.ts';
import { MainConfig } from '@/config/MainConfig.ts';

function App() {
    return (
        <AppInitContainer>
            {isProd() && (
                <MetrikaCounter
                    id={MainConfig.metric.yandex.id}
                    options={{
                        clickmap: true,
                        trackLinks: true,
                        accurateTrackBounce: true,
                        trackHash: true,
                        webvisor: true,
                    }}
                />
            )}
            <ScrollToTop />
            <Routes>
                <Route path={appRoutes.mainPage} element={<MainLayout />}>
                    <Route path="*" element={<ErrorPageNotFound />} />
                    <Route index element={<HomePage />} />
                    <Route path={appRoutes.prettyNums} element={<PrettyNumbersPage />} />
                    <Route path={appRoutes.goodTariffs} element={<GoodTariffsPage />} />
                    <Route path={appRoutes.drugomaniya}>
                        <Route index element={<DrugomaniyaPage />} />
                        <Route
                            path={appRoutes.history}
                            element={
                                <ProtectedRoute>
                                    <HistoryPage />
                                </ProtectedRoute>
                            }
                        />
                    </Route>
                    <Route
                        path={appRoutes.myNumbers}
                        element={
                            <ProtectedRoute>
                                <MyNumbersPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={appRoutes.myReservations}
                        element={
                            <ProtectedRoute>
                                <MyReservationsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route path={appRoutes.privacyPolicy} element={<PrivacyPolicyPage />} />
                    <Route path={appRoutes.termsOfService} element={<TermsOfServicePage />} />
                    <Route path={appRoutes.profile}>
                        <Route index element={<ProfilePage />} />
                        <Route path={appRoutes.help} element={<HelpPage />} />
                        <Route path={appRoutes.loyaltyProgram} element={<LoyaltyProgramPage />} />
                        <Route
                            path={appRoutes.settings}
                            element={
                                <ProtectedRoute>
                                    <SettingPage />
                                </ProtectedRoute>
                            }
                        />
                        {isMobile && (
                            <Route path={appRoutes.about}>
                                <Route
                                    index
                                    element={
                                        <ProtectedRoute>
                                            <AboutPage />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path={appRoutes.privacyPolicy}
                                    element={<PrivacyPolicyPage />}
                                />
                            </Route>
                        )}
                    </Route>
                </Route>
            </Routes>
        </AppInitContainer>
    );
}

export default App;
